// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Format = require("date-fns/format").default;
var SerialId$SmartcutsMacros = require("../../bs-utils/src/SerialId.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var CustomMapBuilders$SmartcutsMacros = require("../../bs-macros-extension/src/CustomMapBuilders.bs.js");
var DataExtraction__DataRecord$SmartcutsMacros = require("./DataExtraction__DataRecord.bs.js");
var GoogleApis__Sheets__Schema$SmartcutsMacros = require("../../bs-googleapis/apis/sheets/GoogleApis__Sheets__Schema.bs.js");
var DataExtraction__DataRecord__Types$SmartcutsMacros = require("./DataExtraction__DataRecord__Types.bs.js");
var DataExtraction__DataRecord__Schema__Types$SmartcutsMacros = require("./DataExtraction__DataRecord__Schema__Types.bs.js");

function cellValue_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ArrayOfString" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.arrayFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ArrayOfString */2,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "String" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* String */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Url" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Url */1,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function cellValue_encode(v) {
  switch (v.TAG | 0) {
    case /* String */0 :
        return [
                "String",
                Decco.stringToJson(v._0)
              ];
    case /* Url */1 :
        return [
                "Url",
                Decco.stringToJson(v._0)
              ];
    case /* ArrayOfString */2 :
        return [
                "ArrayOfString",
                Decco.arrayToJson(Decco.stringToJson, v._0)
              ];
    
  }
}

function attribute_encode(v) {
  switch (v) {
    case /* Text */0 :
        return ["Text"];
    case /* ImageSrc */1 :
        return ["ImageSrc"];
    case /* AltText */2 :
        return ["AltText"];
    case /* LinkUrl */3 :
        return ["LinkUrl"];
    
  }
}

function attribute_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AltText" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AltText */2
                  };
          }
      case "ImageSrc" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ImageSrc */1
                  };
          }
      case "LinkUrl" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* LinkUrl */3
                  };
          }
      case "Text" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Text */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function column_decode(decoder_dataSchema, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var dataNodeId = DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataNodeId"), null));
    if (dataNodeId.TAG === /* Ok */0) {
      var attribute = attribute_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "attribute"), null));
      if (attribute.TAG === /* Ok */0) {
        var path = Decco.arrayFromJson(decoder_dataSchema, Belt_Option.getWithDefault(Js_dict.get(dict$1, "path"), null));
        if (path.TAG === /* Ok */0) {
          var columnName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "columnName"), null));
          if (columnName.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      id: id._0,
                      dataNodeId: dataNodeId._0,
                      attribute: attribute._0,
                      path: path._0,
                      columnName: columnName._0
                    }
                  };
          }
          var e = columnName._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".columnName" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = path._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".path" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = attribute._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".attribute" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = dataNodeId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".dataNodeId" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function cell_decode(decoder_column, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var column = Curry._1(decoder_column, Belt_Option.getWithDefault(Js_dict.get(dict$1, "column"), null));
  if (column.TAG === /* Ok */0) {
    var value = Decco.optionFromJson(cellValue_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
    if (value.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                column: column._0,
                value: value._0
              }
            };
    }
    var e = value._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".value" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = column._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".column" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var columnId_encode = Decco.intToJson;

function cell_encode(encoder_column, v) {
  return Js_dict.fromArray([
              [
                "column",
                Curry._1(encoder_column, v.column)
              ],
              [
                "value",
                Decco.optionToJson(cellValue_encode, v.value)
              ]
            ]);
}

function column_encode(encoder_dataSchema, v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.intToJson(v.id)
              ],
              [
                "dataNodeId",
                DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.t_encode(v.dataNodeId)
              ],
              [
                "attribute",
                attribute_encode(v.attribute)
              ],
              [
                "path",
                Decco.arrayToJson(encoder_dataSchema, v.path)
              ],
              [
                "columnName",
                Decco.stringToJson(v.columnName)
              ]
            ]);
}

var columnId_decode = Decco.intFromJson;

function t_encode(encoder_dataSchema, encoder_column, v) {
  return Js_dict.fromArray([
              [
                "columns",
                Decco.arrayToJson((function (param) {
                        return column_encode(encoder_dataSchema, param);
                      }), v.columns)
              ],
              [
                "rows",
                Decco.arrayToJson((function (param) {
                        return Decco.arrayToJson((function (param) {
                                      return cell_encode(encoder_column, param);
                                    }), param);
                      }), v.rows)
              ]
            ]);
}

function t_decode(decoder_dataSchema, decoder_column, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var columns = Decco.arrayFromJson((function (param) {
          return column_decode(decoder_dataSchema, param);
        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "columns"), null));
  if (columns.TAG === /* Ok */0) {
    var rows = Decco.arrayFromJson((function (param) {
            return Decco.arrayFromJson((function (param) {
                          return cell_decode(decoder_column, param);
                        }), param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "rows"), null));
    if (rows.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                columns: columns._0,
                rows: rows._0
              }
            };
    }
    var e = rows._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".rows" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = columns._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".columns" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function columnRef_encode(v) {
  return [
          "ColumnById",
          Decco.intToJson(v._0)
        ];
}

function columnRef_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "ColumnById") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* ColumnById */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var t_encode$1 = Decco.intToJson;

var t_decode$1 = Decco.intFromJson;

var cmp = Caml_obj.caml_compare;

var MapColumnId = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
      t_encode: t_encode$1,
      t_decode: t_decode$1,
      cmp: cmp
    });

function defaultColumnName_(fullPath, attribute) {
  var prefixies = Belt_Array.map(fullPath, (function (param) {
          var schema = param.schema;
          if (typeof schema === "number") {
            switch (schema) {
              case /* PlainText */0 :
                  return "field";
              case /* Image */1 :
                  return "image";
              case /* LinkContainingManyProperties */2 :
                  return "link";
              
            }
          } else {
            switch (schema.TAG | 0) {
              case /* Link */0 :
                  return "link";
              case /* Headline */1 :
                  return schema._0.hLevel;
              case /* Button */2 :
                  return "button";
              case /* Array */3 :
                  return "list[x]";
              
            }
          }
        }));
  var suffix;
  switch (attribute) {
    case /* Text */0 :
        suffix = "text";
        break;
    case /* ImageSrc */1 :
        suffix = "src";
        break;
    case /* AltText */2 :
        suffix = "alt";
        break;
    case /* LinkUrl */3 :
        suffix = "url";
        break;
    
  }
  return Belt_Array.concat(prefixies, [suffix]).join(".");
}

function defaultColumnName(param) {
  var prefixies = Belt_Array.map(param.path, (function (param) {
          var schema = param.schema;
          if (typeof schema === "number") {
            switch (schema) {
              case /* PlainText */0 :
                  return "field";
              case /* Image */1 :
                  return "image";
              case /* LinkContainingManyProperties */2 :
                  return "link";
              
            }
          } else {
            switch (schema.TAG | 0) {
              case /* Link */0 :
                  return "link";
              case /* Headline */1 :
                  return schema._0.hLevel;
              case /* Button */2 :
                  return "button";
              case /* Array */3 :
                  return "list[x]";
              
            }
          }
        }));
  var suffix;
  switch (param.attribute) {
    case /* Text */0 :
        suffix = "text";
        break;
    case /* ImageSrc */1 :
        suffix = "src";
        break;
    case /* AltText */2 :
        suffix = "alt";
        break;
    case /* LinkUrl */3 :
        suffix = "url";
        break;
    
  }
  return Belt_Array.concat(prefixies, [suffix]).join(".");
}

function getAttributeAsTextValue(attribute, param) {
  var value = param.value;
  var exit = 0;
  switch (value.TAG | 0) {
    case /* PlainText */0 :
        if (attribute === 0) {
          return OptionUtils$SmartcutsMacros.optionalString(value._0);
        }
        exit = 1;
        break;
    case /* Image */1 :
        var match = value._0;
        if (attribute !== 0) {
          switch (attribute) {
            case /* ImageSrc */1 :
                return match.src;
            case /* AltText */2 :
                return match.altText;
            case /* LinkUrl */3 :
                exit = 1;
                break;
            
          }
        } else {
          exit = 1;
        }
        break;
    case /* Link */2 :
        var match$1 = value._0;
        if (attribute === 0) {
          return OptionUtils$SmartcutsMacros.optionalString(match$1.innerText);
        }
        if (attribute >= 3) {
          return match$1.url;
        }
        exit = 1;
        break;
    case /* LinkContainingManyProperties */3 :
        if (attribute >= 3) {
          return value._0;
        }
        exit = 1;
        break;
    case /* Headline */4 :
        if (attribute === 0) {
          return OptionUtils$SmartcutsMacros.optionalString(value._0.innerText);
        }
        exit = 1;
        break;
    case /* Button */5 :
        var match$2 = value._0;
        if (attribute === 0) {
          return OptionUtils$SmartcutsMacros.optionalString(match$2.innerText);
        }
        if (attribute >= 3) {
          return match$2.maybeHref;
        }
        exit = 1;
        break;
    case /* Array */6 :
        var texts = value._0;
        switch (texts.TAG | 0) {
          case /* PlainTexts */0 :
              if (attribute === 0) {
                return OptionUtils$SmartcutsMacros.optionalString(Belt_Array.keepMap(texts._0, OptionUtils$SmartcutsMacros.optionalString).join(", "));
              }
              exit = 1;
              break;
          case /* Links */2 :
              if (attribute === 0) {
                return OptionUtils$SmartcutsMacros.optionalString(Belt_Array.map(texts._0, (function (param) {
                                    return OptionUtils$SmartcutsMacros.optionalString(param.innerText);
                                  })).join(", "));
              }
              exit = 1;
              break;
          case /* Headlines */3 :
              if (attribute === 0) {
                return OptionUtils$SmartcutsMacros.optionalString(Belt_Array.map(texts._0, (function (param) {
                                    return OptionUtils$SmartcutsMacros.optionalString(param.innerText);
                                  })).join(", "));
              }
              exit = 1;
              break;
          case /* Buttons */4 :
              if (attribute === 0) {
                return OptionUtils$SmartcutsMacros.optionalString(Belt_Array.keepMap(texts._0, (function (param) {
                                    return OptionUtils$SmartcutsMacros.optionalString(param.innerText);
                                  })).join(", "));
              }
              exit = 1;
              break;
          case /* Images */1 :
          case /* Records */5 :
              exit = 2;
              break;
          
        }
        break;
    
  }
  switch (exit) {
    case 1 :
    case 2 :
        console.warn("trying to getAttributeAsTextValue(", value, attribute, ")");
        return ;
    
  }
}

function rowFromDataNodeWithId(columns, dataRecord) {
  return Belt_Array.map(columns, (function (param) {
                var attribute = param.attribute;
                var func = DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.getDataNodesById;
                var values = Belt_Array.keepMap(Curry._2(func, param.dataNodeId, dataRecord), (function (param) {
                        return getAttributeAsTextValue(attribute, param);
                      }));
                var len = values.length;
                var value;
                if (len !== 1) {
                  value = len !== 0 ? ({
                        TAG: /* ArrayOfString */2,
                        _0: values
                      }) : undefined;
                } else {
                  var textValue = values[0];
                  value = textValue === "" ? undefined : (
                      attribute !== 1 && attribute < 3 ? ({
                            TAG: /* String */0,
                            _0: textValue
                          }) : ({
                            TAG: /* Url */1,
                            _0: textValue
                          })
                    );
                }
                return {
                        column: /* ColumnById */{
                          _0: param.id
                        },
                        value: value
                      };
              }));
}

function attributesFromDataSchema(dataSchema, dataRecordsWithDataNodeId) {
  var schema = dataSchema.schema;
  var dataNodeId = dataSchema.dataNodeId;
  var exit = 0;
  if (typeof schema === "number") {
    switch (schema) {
      case /* PlainText */0 :
          return [/* Text */0];
      case /* Image */1 :
          exit = 1;
          break;
      case /* LinkContainingManyProperties */2 :
          return [/* LinkUrl */3];
      
    }
  } else {
    switch (schema.TAG | 0) {
      case /* Link */0 :
          return [
                  /* LinkUrl */3,
                  /* Text */0
                ];
      case /* Headline */1 :
          return [/* Text */0];
      case /* Button */2 :
          exit = 2;
          break;
      case /* Array */3 :
          var match = schema._0;
          if (typeof match === "number") {
            if (match === /* PlainTexts */0) {
              return [/* Text */0];
            }
            exit = 1;
          } else {
            switch (match.TAG | 0) {
              case /* Links */0 :
                  return [
                          /* LinkUrl */3,
                          /* Text */0
                        ];
              case /* Headlines */1 :
                  return [/* Text */0];
              case /* Buttons */2 :
                  exit = 2;
                  break;
              case /* Records */3 :
                  return ArrayUtils$SmartcutsMacros.flatMap((function (param) {
                                return attributesFromDataSchema(param.dataSchema, dataRecordsWithDataNodeId);
                              }), match._0.properties);
              
            }
          }
          break;
      
    }
  }
  switch (exit) {
    case 1 :
        var arg = ArrayUtils$SmartcutsMacros.flatMap((function (param) {
                return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.getDataNodesById(dataNodeId, param);
              }), dataRecordsWithDataNodeId);
        return Belt_Array.concat(OptionUtils$SmartcutsMacros.toArray(Belt_Option.map((function (param) {
                                return ArrayUtils$SmartcutsMacros.firstMatch(param, arg);
                              })(function (dataNode) {
                                var match = dataNode.value;
                                if (match.TAG === /* Image */1) {
                                  return match._0.altText !== undefined;
                                } else {
                                  return false;
                                }
                              }), (function (_altText) {
                              return /* AltText */2;
                            }))), [/* ImageSrc */1]);
    case 2 :
        var arg$1 = ArrayUtils$SmartcutsMacros.flatMap((function (param) {
                return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.getDataNodesById(dataNodeId, param);
              }), dataRecordsWithDataNodeId);
        return Belt_Array.concat(OptionUtils$SmartcutsMacros.toArray(Belt_Option.map((function (param) {
                                return ArrayUtils$SmartcutsMacros.firstMatch(param, arg$1);
                              })(function (dataNode) {
                                var match = dataNode.value;
                                if (match.TAG === /* Button */5) {
                                  return match._0.maybeHref !== undefined;
                                } else {
                                  return false;
                                }
                              }), (function (_href) {
                              return /* LinkUrl */3;
                            }))), [/* Text */0]);
    
  }
}

function fromDataRecords(param) {
  var dataRecords = param.dataRecords;
  var makeId = SerialId$SmartcutsMacros.makeIdGenerator(undefined);
  var arg = param.unifiedSchema.properties;
  var arg$1 = Belt_Array.keep((function (param) {
            return ArrayUtils$SmartcutsMacros.flatMap(param, arg);
          })(function (param) {
            return Curry._2(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.DataNodeSchema.allNodesWithPath, param.dataSchema, DataExtraction__DataRecord$SmartcutsMacros.Schema.WithHTPIAndTagPathAndDataNodeId.valueFromDataSchema);
          }), (function (param) {
          var match = ArrayUtils$SmartcutsMacros.last(param[1]);
          if (param[0].schema !== 0) {
            return true;
          }
          if (match === undefined) {
            return true;
          }
          var tmp = match.schema;
          if (typeof tmp === "number") {
            return true;
          }
          switch (tmp.TAG | 0) {
            case /* Link */0 :
            case /* Button */2 :
                return false;
            default:
              return true;
          }
        }));
  var columns = (function (param) {
        return ArrayUtils$SmartcutsMacros.flatMap(param, arg$1);
      })(function (param) {
        var path = param[1];
        var dataSchema = param[0];
        return Belt_Array.keepMap(attributesFromDataSchema(dataSchema, dataRecords), (function (attribute) {
                      var dataNodeId = dataSchema.dataNodeId;
                      var fullPath = Belt_Array.concat(path, [dataSchema]);
                      var _values = ArrayUtils$SmartcutsMacros.flatMap((function (dataRecord) {
                              var func = DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.getDataNodesById;
                              return Belt_Array.keepMap(Curry._2(func, dataNodeId, dataRecord), (function (param) {
                                            return getAttributeAsTextValue(attribute, param);
                                          }));
                            }), dataRecords);
                      if (_values.length !== 0) {
                        return {
                                id: Curry._1(makeId, undefined),
                                dataNodeId: dataNodeId,
                                attribute: attribute,
                                path: fullPath,
                                columnName: defaultColumnName_(fullPath, attribute)
                              };
                      }
                      
                    }));
      });
  var rows = Belt_Array.map(dataRecords, (function (param) {
          return rowFromDataNodeWithId(columns, param);
        }));
  return {
          columns: columns,
          rows: rows
        };
}

function resolveCellValueAsText(cellValue) {
  switch (cellValue.TAG | 0) {
    case /* String */0 :
    case /* Url */1 :
        return cellValue._0;
    case /* ArrayOfString */2 :
        return cellValue._0.join(", ");
    
  }
}

function t_encode$2(v) {
  if (v) {
    return ["CurrentUrl"];
  } else {
    return ["CurrentDateTime"];
  }
}

function t_decode$2(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CurrentDateTime" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CurrentDateTime */0
                  };
          }
      case "CurrentUrl" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CurrentUrl */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var allExtraColumns = [
  /* CurrentDateTime */0,
  /* CurrentUrl */1
];

function stringify(extraColumn) {
  if (extraColumn) {
    return "CurrentUrl";
  } else {
    return "CurrentDateTime";
  }
}

function columnName(extraColumn) {
  if (extraColumn) {
    return "Saved from web page";
  } else {
    return "Saved at date time";
  }
}

var ExtraColumn = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  allExtraColumns: allExtraColumns,
  stringify: stringify,
  columnName: columnName
};

function fromCellValue(cellValue) {
  switch (cellValue.TAG | 0) {
    case /* String */0 :
        return {
                TAG: /* Text */0,
                _0: cellValue._0
              };
    case /* Url */1 :
        return {
                TAG: /* Link */1,
                _0: cellValue._0
              };
    case /* ArrayOfString */2 :
        return {
                TAG: /* Text */0,
                _0: cellValue._0.join(", ")
              };
    
  }
}

function fromExtraColumn(extraColumn, currentUrl, maybeCurrentDateTime, param) {
  if (extraColumn) {
    return {
            TAG: /* Link */1,
            _0: currentUrl
          };
  } else {
    return {
            TAG: /* DateTime */2,
            _0: OptionUtils$SmartcutsMacros.withDefault(new Date(), maybeCurrentDateTime)
          };
  }
}

function resolveAsText(cellContent) {
  switch (cellContent.TAG | 0) {
    case /* Text */0 :
    case /* Link */1 :
        return cellContent._0;
    case /* DateTime */2 :
        return Format(cellContent._0, "eeee, M/d/yyyy 'at' h:mm");
    
  }
}

function resolveAsCellData(cellContent, dataValidation, param) {
  switch (cellContent.TAG | 0) {
    case /* Text */0 :
        return GoogleApis__Sheets__Schema$SmartcutsMacros.CellData.make(dataValidation, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, GoogleApis__Sheets__Schema$SmartcutsMacros.ExtendedValue.stringValue(cellContent._0), undefined);
    case /* Link */1 :
        return GoogleApis__Sheets__Schema$SmartcutsMacros.CellData.make(dataValidation, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, GoogleApis__Sheets__Schema$SmartcutsMacros.ExtendedValue.formulaValue("=HYPERLINK(\"" + cellContent._0 + "\")"), undefined);
    case /* DateTime */2 :
        var datetime = cellContent._0;
        var dateString = datetime.toDateString();
        var timeString = Format(datetime, "HH:mm:ss");
        return GoogleApis__Sheets__Schema$SmartcutsMacros.CellData.make(dataValidation, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
                    numberFormat: GoogleApis__Sheets__Schema$SmartcutsMacros.NumberFormat.make("DATE_TIME", "dddd, m/d/yyyy at h:mm")
                  }, GoogleApis__Sheets__Schema$SmartcutsMacros.ExtendedValue.formulaValue("=DATEVALUE(\"" + dateString + "\") + TIMEVALUE(\"" + timeString + "\")"), undefined);
    
  }
}

var CellContent = {
  fromCellValue: fromCellValue,
  fromExtraColumn: fromExtraColumn,
  resolveAsText: resolveAsText,
  resolveAsCellData: resolveAsCellData
};

var GoogleSheet = {
  CellContent: CellContent
};

var DataRecord;

var DataRecordsAndSchema;

exports.DataRecord = DataRecord;
exports.DataRecordsAndSchema = DataRecordsAndSchema;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.column_encode = column_encode;
exports.column_decode = column_decode;
exports.columnId_encode = columnId_encode;
exports.columnId_decode = columnId_decode;
exports.columnRef_encode = columnRef_encode;
exports.columnRef_decode = columnRef_decode;
exports.attribute_encode = attribute_encode;
exports.attribute_decode = attribute_decode;
exports.cell_encode = cell_encode;
exports.cell_decode = cell_decode;
exports.cellValue_encode = cellValue_encode;
exports.cellValue_decode = cellValue_decode;
exports.MapColumnId = MapColumnId;
exports.defaultColumnName = defaultColumnName;
exports.rowFromDataNodeWithId = rowFromDataNodeWithId;
exports.fromDataRecords = fromDataRecords;
exports.resolveCellValueAsText = resolveCellValueAsText;
exports.ExtraColumn = ExtraColumn;
exports.GoogleSheet = GoogleSheet;
/* MapColumnId Not a pure module */
